import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { selectAppVisible, checkSignedIn } from "reducers/auth";

export function useCheckSignedIn(): boolean {
  const dispatch = useDispatch();
  const isAppVisible = useSelector(selectAppVisible);

  useEffect(() => {
    dispatch(checkSignedIn());
  }, [dispatch]);

  return isAppVisible;
}
